import { getVendor } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useVendor() {
  //Fetching Vendor Details
  return useQuery("GetVendor", getVendor, {
    refetchOnWindowFocus: false,
  });
}
